import React from 'react';
import PropTypes from 'prop-types';
import { TextField, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  input: {
    height: 40,
    background: "#fff",
    font: "400 13px/18px TIM Sans",
    letterSpacing: "0",
    color: "#000000",
  },
  labelRoot: {
    fontSize: 13,
    lineHeight: '1px',
    "&$labelFocused": {
      color: "#212c64"
    }
  },
  labelFocused: {},
  shrink: {
    lineHeight: '15px'
  },
  menuFont: {
    font: "400 13px/18px TIM Sans",
  }
});

export default function CustomSelect(props) {
  const classes = useStyles();

  return (
    <TextField
      className={props.className}
      fullWidth
      select
      InputLabelProps={{
        classes: {
          root: classes.labelRoot,
          shrink: classes.shrink,
          focused: classes.labelFocused
        },
        shrink : props.shrink
      }}
      InputProps={{
        labelWidth: props.labelWidth,
        className: classes.input
      }}
      SelectProps={{
        renderValue: item => props.multiOptionLabel ? item[props.firstOptionLabel] + ' ' + item[props.secondOptionLabel] : props.optionLabel ? item[props.optionLabel] : item,
        MenuProps: {
          onScroll: props.getMoreFunction
        },
        classes: props['selectClasses']
      }}
      classes={props.classes ? props.classes : null}
      disabled={props.disabled ? props.disabled : false}
      label={props.label}
      name={props.name}
      value={props.value}
      margin="normal"
      onChange={props.onChange}
      variant="outlined"
    >
      {props.options.length > 0 && props.blankOption ? <MenuItem value="" style={{ height: '36px' }}></MenuItem> : null}
      {props.options.map((elem, index) => (
        props.multiOptionLabel ?
          <MenuItem className={classes.menuFont} key={index} value={props.menuValue ? props.menuValue(elem) : elem}>
            {props.multiOptionLabel ? elem[props.firstOptionLabel] + ' ' + elem[props.secondOptionLabel] : elem}
          </MenuItem>
          :
          <MenuItem className={classes.menuFont} key={index} value={props.menuValue ? props.menuValue(elem) : elem}>
            {props.optionLabel ? elem[props.optionLabel] : elem}
          </MenuItem>
      ))}
      {
        props.options.length === 0 ? <MenuItem className={classes.menuFont} disabled>
          Nessun elemento trovato
        </MenuItem> : null}
    </TextField>
  )
}

/**
 *  @param options : Lista a cui applicare la select
 *  @param optionLabel : key da visualizzare
 *  @param value : valore autocomplete
 *  @param onChange : funzione on change
 *  @param label : label visualizzazione
 *  @param name : nome
 */
CustomSelect.propTypes = {
  options: PropTypes.array.isRequired,
  SelectProps: PropTypes.func,
  optionLabel: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired
};